import React from "react";
import Layout from "components/Layout";
import { Box, Text } from "@chakra-ui/react";
import Head from "next/head";

const EqualOpportunities: React.FC = () => {
  return (
    <Layout>
      <Head>
        <title>101Digital | Equal Opportunities</title>
      </Head>
      <Text
        as="h1"
        textStyle="h1"
        textAlign={["center", null, null, null, null, "left"]}
        mb={["34px", null, null, null, null, "136px"]}
        mt={["45px", null, null, null, null, "132px"]}
      >
        <Text>Equal Opportunities</Text>
      </Text>
      <Box
        maxW="1155px"
        w="100%"
        mb={["34px", null, null, null, null, "99px"]}
        px={["28px", null, null, null, null, "16px"]}
      >
        <Text
          textStyle="paragraph"
          color="primary"
          fontSize={["12px", null, null, null, null, "21px"]}
          fontWeight={300}
        >
          The Company considers all forms of discrimination to be unacceptable
          in the workplace. The Company is committed to providing equal
          opportunities throughout employment, including in the remuneration,
          recruitment, training and promotion of staff.
          <br />
          <br />
          The Company is committed to ensuring that no employee receives less
          favourable treatment or is unlawfully discriminated against on grounds
          of disability, gender, sex, sexual orientation, marital status, race,
          colour, religious convictions, age, nationality or ethnic origin.
          <br />
          <br />
          The Company is an equal opportunities employer. All appointments and
          promotions are made on the basis of performance and ability. We are
          committed to the continued development of the personal and business
          skills of our employees and you will be treated in a fair and unbiased
          way and given every encouragement to realise your potential.
          <br />
          <br />
          All employees will be made aware of the provisions of this policy and
          all employees are required to ensure that the policy is carried out
          properly as in addition to being committed to equal opportunities
          internally within the workplace, the Company is committed to clients
          and Candidates being treated equally.
          <br />
          <br />
          The Company is committed to its Candidates being assessed in
          accordance with their merits and qualifications and ability to perform
          the relevant duties required by a particular vacancy. The Company will
          not tolerate unlawful discrimination against or towards any Candidates
          or client or prospective client.
        </Text>
      </Box>
    </Layout>
  );
};

export default EqualOpportunities;
